import { HeroSection, Modules } from 'components';
import _get from 'lodash.get';
import React, { PureComponent } from 'react';

class Sections extends PureComponent {
    constructor(props) {
        super(props);
    }

    renderHeroSections() {
        // Get hero sections
        const heroSections = _get(this.props, 'data.page.hero', []);
        const pageData = _get(this.props, 'data.page', []);

        const caseSections = [];
        this.props.data.page.modules.forEach(el => {
            if (el && el.__typename == 'DatoCmsCaseSection') {
                caseSections.push({
                    sectionTitle: el.sectionTitle,
                    id: el.id,
                });
            }
        });

        //Get background color - first from section, otherwise from page
        const backgroundColor = _get(
            heroSections,
            'backgroundColor.hex',
            _get(this.props, 'data.page.backgroundColor.hex', '#fff')
        );

        //Get text color - first from section, otherwise from page
        const textColor = _get(
            heroSections,
            'textColor.hex',
            _get(this.props, 'data.page.textColor.hex', '#000')
        );
        return heroSections.length ? (
            <HeroSection
                modules={heroSections}
                data={pageData}
                backgroundColor={backgroundColor}
                textColor={textColor}
                showArrowCursor={true}
                caseSections={caseSections}
            />
        ) : (
            ''
        );
    }

    renderSections() {
        // Get sections
        const sections = _get(this.props, 'data.page.modules', []);

        return sections.map(section => {
            if (!section) {
                return '';
            }

            //Get background color - first from section, otherwise from page
            const backgroundColor = _get(
                section,
                'backgroundColor.hex',
                _get(this.props, 'data.page.backgroundColor.hex', '#fff')
            );

            //Get text color - first from section, otherwise from page
            const textColor = _get(
                section,
                'textColor.hex',
                _get(this.props, 'data.page.textColor.hex', '#000')
            );
            section.backgroundColor = { hex: backgroundColor };
            section.textColor = { hex: textColor };
            return (
                <Modules
                    key={section.id}
                    {...{
                        ...this.props,
                        content: section,
                    }}
                />
            );
        });
    }

    render() {
        return (
            <div>
                {!this.props.skipHero && this.renderHeroSections()}
                <div style={{ position: 'relative' }}>
                    {this.renderSections()}
                </div>
            </div>
        );
    }
}

export default Sections;
